import { html, LitElement, unsafeCSS } from 'lit';
import styles from './fileUploader.scss?inline';
import { ref } from 'lit/directives/ref.js';
import { ATTRIBUTES, BYTES_IN_KB, BYTES_IN_MB } from './constants';
export default class SotbitFileUploader extends LitElement {
    static formAssociated = true;

    static properties = {
        label: { type: String },
        name: { type: String },
        disabled: { type: Boolean },
        inputCaption: { type: String, attribute: ATTRIBUTES.INPUT_CAPTION },
        maxSize: { type: String, attribute: ATTRIBUTES.MAX_SIZE },
        value: { type: Object },
    };

    constructor() {
        super();

        this._internals = this.attachInternals();
        this.label = '';
        this.name = 'file';
        this.disabled = false;
        this.inputCaption = '';
        this.maxSize = '';
        this.value = null;
        this.files = [];
    }

    createRenderRoot() {
        return this;
    }

    formResetCallback() {
        this.files = [];

        if (this._hiddenInput) {
            this._hiddenInput.value = '';
        }

        this.requestUpdate();
    }

    handleFileChange(e) {
        const files = Array.from(e.target.files);
        this.files = files.map((file) => ({
            name: file.name,
            size: file.size,
            url: URL.createObjectURL(file),
            raw: file,
        }));

        this.requestUpdate();
    }

    handleDelete(file) {
        this.files = this.files.filter((f) => f !== file);

        if (this.files.length === 0 && this._hiddenInput) {
            this._hiddenInput.value = '';
        }

        this.requestUpdate();
    }

    formatSize(bytes) {
        if (bytes < BYTES_IN_KB) {
            return bytes + ' B';
        }

        if (bytes < BYTES_IN_MB) {
            return (bytes / BYTES_IN_KB).toFixed(1) + ' KB';
        }

        return (bytes / BYTES_IN_MB).toFixed(1) + ' MB';
    }

    _triggerFileDialog() {
        if (this._hiddenInput && !this.disabled) {
            this._hiddenInput.click();
        }
    }

    render() {
        return html`
            <style>
                ${unsafeCSS(styles)}
            </style>
            <div class="file-uploader">
                ${this.label ? html`<p class="file-uploader__title">${this.label}</p>` : ''}
                <div class="file-uploader__input-area">
                    <sotbit-button
                        variant="secondary"
                        background
                        outline
                        inline
                        @click=${this._triggerFileDialog.bind(this)}
                        ?disabled=${this.disabled}
                    >
                        <span slot="content">${this.inputCaption}</span>
                    </sotbit-button>
                    <input
                        type="file"
                        name=${this.name}
                        ?disabled=${this.disabled}
                        @change=${this.handleFileChange}
                        style="display: none"
                        ${ref((el) => (this._hiddenInput = el))}
                    />
                </div>

                ${this.files.length
                    ? html`
                          <div class="file-uploader__list">
                              ${this.files.map((file) => {
                                  const isImage = file.raw?.type?.startsWith('image/');
                                  return html`
                                      <div class="file-item">
                                          ${isImage
                                              ? html`<img
                                                    class="file-item__preview"
                                                    src=${file.url}
                                                    alt=${file.name}
                                                />`
                                              : html`
                                                    <div class="file-item__icon">
                                                        <sotbit-icon icon="docs"></sotbit-icon>
                                                    </div>
                                                `}
                                          <span class="file-item__name">${file.name}</span>
                                          <span class="file-item__size">${this.formatSize(file.size || 0)}</span>
                                          <sotbit-button-icon
                                              variant="secondary"
                                              @click=${() => this.handleDelete(file)}
                                          >
                                              <sotbit-icon slot="content" icon="close"></sotbit-icon>
                                          </sotbit-button-icon>
                                      </div>
                                  `;
                              })}
                          </div>
                      `
                    : ''}
                ${this.maxSize ? html`<span class="file-uploader__max-size">${this.maxSize}</span>` : ''}
            </div>
        `;
    }
}
